// extracted by mini-css-extract-plugin
export default {"Container":"extension_Container__7CqOy","section-1":"extension_section-1__xfisd","content":"extension_content__m4iZ-","section-2":"extension_section-2__hThiS"};